import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getDrivingTestStore = (state: RootState) => state.drivingTestStore;
const drivingTest = createSelector(getDrivingTestStore, (state) => state.drivingTest);
const drivingTestSummary = createSelector(getDrivingTestStore, (state) => state.drivingTestSummary);

export { drivingTest, drivingTestSummary };
